// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, boolean, string, nullOrUndefined, maybeNumber } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignsDataV2Result = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      campaign_name: string,
      campaign_description: string,
      id: string,
      app_group_id: string,
      enabled: boolean,
      is_currently_expired: boolean,
      schedule_type: string,
      schedule_data: objectOf({
        start_date_time: number,
        deliver_in_local_time: boolean,
        optimal_time_notification: boolean,
        use_app_group_best_time: nullOrUndefined,
        optimal_time_default_hour: nullOrUndefined,
        optimal_time_default_minute: nullOrUndefined,
        quiet_start_hour: nullOrUndefined,
        quiet_start_minute: nullOrUndefined,
        quiet_end_hour: nullOrUndefined,
        quiet_end_minute: nullOrUndefined,
        has_quiet_time: boolean,
        content_card_delivery_control: nullOrUndefined,
        display_text: string,
        next_occurrence: nullOrUndefined,
        last_occurrence: number,
        recurring: boolean,
      }),
      created: objectOf({
        time: number,
        name: string,
      }),
      last_edit: objectOf({
        time: number,
        name: string,
      }),
      is_archived: boolean,
      is_draft: boolean,
      campaign_type: string,
      tag_names: arrayOf(nullOrUndefined),
      territory_ids: arrayOf(nullOrUndefined),
      can_be_copied_across_app_groups: boolean,
      total_sent: number,
    })
  ),
  idle_count: number,
  targeting_complexity_threshold_count: maybeNumber,
});
